import { FlowRoute } from 'utils/FlowProvider/types'
import removeDuplicateQueryParams, { IMPACT_RADIUS_SOURCE } from 'utils/sourceAttributes'

type SourceAttributesProps = {
  flow: string
  location: any
  partner: any
}

const TIERED_REG_STRING = 'tiered_reg'

export const getSourceAttributes = (options: SourceAttributesProps) => {
  const currentFlow = options.flow?.toLowerCase() === 'tiered' ? TIERED_REG_STRING : options.flow

  let sourceId = options.partner?.org?.name
  if (window.location.href.includes(FlowRoute.Signup)) {
    // Determine the source of this user's arrival to Acorns
    const unfilteredQueryParamAttributes = removeDuplicateQueryParams(window.location.search)
    const unfilteredStoredAttributes = removeDuplicateQueryParams(options.location.state?.params)

    sourceId = sourceId ?? unfilteredQueryParamAttributes.s1

    // Note: If the `clickid` query param exists set the source.id as `impactradius`
    if (unfilteredQueryParamAttributes.clickid) {
      sourceId = IMPACT_RADIUS_SOURCE
    }

    // Extract referral_code from queryParamsObject for additional manipulation
    const {
      referral_code: referralCode,
      ...filteredQueryParamAttributes
    } = unfilteredQueryParamAttributes

    // Extract tierPriceId from storedParams, use the tierPriceId value defined in queryParams instead
    const { tierPriceId, ...filteredStoredAttributes } = unfilteredStoredAttributes

    const attributes = {
      ...filteredQueryParamAttributes,
      ...filteredStoredAttributes,
      ...(referralCode && { referralCode }),
      flow: currentFlow,
    }

    // Store in session so that page calls further in the flow have access to these landing page attributionSource variables
    window?.sessionStorage.setItem('ATTR_SRC_ID', sourceId)
    attributes?.tierPriceId &&
      window?.sessionStorage.setItem('ATTR_SRC_TIER_PRICE_ID', attributes.tierPriceId)
    window?.sessionStorage.setItem('ATTR_SRC_REF_CODE', attributes?.referralCode)

    return {
      sourceId,
      attributes,
    }
  } else {
    // Since there is no longer data in the queryParams, return attribution data that has already been saved
    sourceId = window?.sessionStorage.getItem('ATTR_SRC_ID')
    const tierPriceId = window?.sessionStorage.getItem('ATTR_SRC_TIER_PRICE_ID')
    const referralCode = window?.sessionStorage.getItem('ATTR_SRC_REF_CODE')

    return {
      ...(sourceId && { sourceId }),
      attributes: {
        flow: currentFlow,
        ...(tierPriceId && { tierPriceId }),
        ...(referralCode && { referralCode }),
      },
    }
  }
}
